import {fetchRoutes} from "../network/RouteNetworkAPI";
import {
    allRouteMetricAvailable,
    computeRouteCounts,
    getInductedData,
    getPickedData,
    getStowedData
} from "../../util/Util";

export const RouteReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {dispatcher, isCore, baseUrl, capability, stationConfig} = action.data;
            fetchRoutes(dispatcher, isCore, baseUrl, capability, stationConfig)
            return state
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "RECEIVE_NON_CORE_ROUTE":
            return {...state, ...action.data}
        case "RECEIVE_PICK_DATA":
        {
            const capability = action.data.capability;
            const packageMetric = action.data.pickData;
            const routeData =  getPickedData(packageMetric, state)
            let newState = {...state, ...routeData};
            newState.metricAvailability.pick = true;
            newState.metricAvailability.stage = true;
            newState.metricAvailability.depart = true;
            if (allRouteMetricAvailable(newState)) {
                newState = computeRouteCounts(newState, capability);
            }
            return newState;
        }
        case "RECEIVE_INDUCT_DATA":
        {
            const capability = action.data.capability;
            const packageMetric = action.data.inductData;
            const routeData = getInductedData(packageMetric, state)
            let newState = {...state, ...routeData};
            newState.metricAvailability.induct = true;
            if (allRouteMetricAvailable(newState)) {
                newState = computeRouteCounts(newState, capability);
            }
            return newState;
        }
        case "RECEIVE_STOW_DATA":
        {
            const capability = action.data.capability;
            const packageMetric = action.data.stowData;
            const routeData = getStowedData(packageMetric, state)
            let newState = {...state, ...routeData};
            newState.metricAvailability.stow = true;
            if (allRouteMetricAvailable(newState)) {
                newState = computeRouteCounts(newState, capability);
            }
            return newState;
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/routeView/reducers/RouteReducer.js